import {
  BackOutlineIcon,
  CloseOutlineIcon,
  ForwardOutlineIcon,
  RefreshOutlineIcon,
} from '@carboncopyco/icons';
import { Button, TooltipBubble } from '@carboncopyco/ui';

interface BrowserNavbarNavigationProps {
  isBackDisabled: boolean;
  isForwardDisabled: boolean;
  onBack: () => void;
  onForward: () => void;
  onReloadNavigation?: () => void;
  onStopReloadNavigation?: () => void;
  isLoadingNavigation?: boolean;
}

export const BrowserNavbarNavigation = ({
  isBackDisabled,
  isForwardDisabled,
  onBack,
  onForward,
  onReloadNavigation,
  onStopReloadNavigation,
  isLoadingNavigation,
}: BrowserNavbarNavigationProps) => {
  return (
    <div className="flex space-x-2.5">
      <div className="flex items-center justify-center w-10">
        <TooltipBubble
          placement="top"
          title="Backward"
        >
          <div className="text-ds-accent3-100">
            <Button
              linkDark
              icon={<BackOutlineIcon />}
              disabled={isBackDisabled}
              onClick={onBack}
            />
          </div>
        </TooltipBubble>
      </div>

      <div className="flex items-center justify-center w-10">
        <TooltipBubble
          placement="top"
          title="Forward"
        >
          <div className="text-ds-accent3-100">
            <Button
              linkDark
              icon={<ForwardOutlineIcon />}
              disabled={isForwardDisabled}
              onClick={onForward}
            />
          </div>
        </TooltipBubble>
      </div>

      {onReloadNavigation && onStopReloadNavigation && (
        <>
          {isLoadingNavigation ? (
            <div className="flex items-center justify-center w-10">
              <TooltipBubble
                placement="top"
                title="Stop loading"
              >
                <div className="text-ds-accent3-100">
                  <Button
                    linkDark
                    icon={<CloseOutlineIcon />}
                    onClick={onStopReloadNavigation}
                  />
                </div>
              </TooltipBubble>
            </div>
          ) : (
            <div className="flex items-center justify-center w-10">
              <TooltipBubble
                placement="top"
                title="Refresh"
              >
                <div className="text-ds-accent3-100">
                  <Button
                    linkDark
                    icon={<RefreshOutlineIcon />}
                    onClick={onReloadNavigation}
                  />
                </div>
              </TooltipBubble>
            </div>
          )}
        </>
      )}
    </div>
  );
};
